module.exports = __webpack_public_path__ + "img/24.f6c238e4.png";